import { createReducer, on } from '@ngrx/store';

import { SortOrder } from '@common/utils/search-sort';
import {
  addObject,
  deleteObjectById,
  setLastPageStateObjects,
  setLoaded,
  setTrackedObjectId,
  stopTrackedAllObjects,
  storeObjects,
  updateConnectedStatusForObject,
  updateLastMessageForObjects,
  updateMultipleObjects,
  updateObjectById,
} from '@store/actions/objects.actions';
import { AvailableTabsOnPage, LastPageStateWithTabs } from '@store/types/basic-last-page-state';

export interface ObjectsState {
  list: any[];
  loaded: boolean;
  trackedObjectIds: number[];
  lastPageState: LastPageStateWithTabs;
}

export const initialStateObjects: ObjectsState = {
  list: [],
  loaded: false,
  trackedObjectIds: [],
  lastPageState: {
    activeTabOnPage: AvailableTabsOnPage.List,
    [AvailableTabsOnPage.List]: {
      searchValue: '',
      sortOrder: SortOrder.Asc,
    },
    [AvailableTabsOnPage.Groups]: {
      searchValue: '',
      sortOrder: SortOrder.Asc,
      openedGroupId: null,
      isOpenedFreeList: false,
    },
  },
};

export const objectsReducer = createReducer(
  initialStateObjects,
  on(setLoaded, (state, { loaded }) => ({ ...state, loaded })),
  on(setLastPageStateObjects, (state, { newPageState }) => {
    return {
      ...state,
      lastPageState: {
        ...state.lastPageState,
        ...newPageState,
      },
    };
  }),
  on(setTrackedObjectId, (state, { objectId }) => {
    const currentTrackedObjectIds = state.trackedObjectIds;

    // TODO: Для реализации с несколькими отслеживаемыми объектами
    // const newTrackedObjectIds = currentTrackedObjectIds.includes(objectId)
    //   ? currentTrackedObjectIds.filter((id) => id !== objectId)
    //   : [...currentTrackedObjectIds, objectId];

    const newTrackedObjectIds = currentTrackedObjectIds.includes(objectId) ? [] : [objectId];

    return { ...state, trackedObjectIds: newTrackedObjectIds };
  }),

  on(stopTrackedAllObjects, (state) => {
    return { ...state, trackedObjectIds: [] };
  }),

  on(storeObjects, (state, { list }) => ({ ...state, list, loaded: true })),
  on(updateLastMessageForObjects, (state, data) => {
    return {
      ...state,
      list: state.list.map((object: any) => {
        const info = data[object.id];
        return info
          ? {
              ...object,
              lastMessage: info
                ? {
                    ...object.lastMessage,
                    ...{
                      ...info,
                      pos: info?.pos ? info.pos : object.lastMessage?.pos,
                    },
                  }
                : object.lastMessage,
            }
          : object;
      }),
    };
  }),
  on(updateConnectedStatusForObject, (state, data) => {
    return {
      ...state,

      list: state.list.map((object: any) => {
        return data.oid === object.id
          ? {
              ...object,
              connectedStatus: data ? data.connectedStatus : object.connectedStatus,
            }
          : object;
      }),
    };
  }),
  on(updateObjectById, (state, data) => {
    const { updatedObject } = data;
    const list = state.list.map((object: any) => {
      return object.id === updatedObject.id ? { ...object, ...updatedObject } : object;
    });

    return {
      ...state,
      list: list,
    };
  }),

  on(updateMultipleObjects, (state, data) => {
    const { updatedObjects } = data;
    const updatedObjectsMap = new Map(updatedObjects.map((obj: any) => [obj.id, obj]));

    const list = state.list.map((object: any) => {
      const updatedObject = updatedObjectsMap.get(object.id);
      return updatedObject ? { ...object, ...updatedObject } : object;
    });

    return {
      ...state,
      list: list,
    };
  }),

  on(addObject, (state, data) => {
    const { createdObject } = data;
    const existingObject = state.list.find((obj: any) => obj.id === createdObject.id);

    if (!existingObject) {
      const newList = [createdObject, ...state.list];
      return {
        ...state,
        list: newList,
      };
    }

    return state;
  }),
  on(deleteObjectById, (state, data) => {
    const { deletedObjectId } = data;
    return {
      ...state,
      list: state.list.filter((object: any) => object.id !== deletedObjectId),
    };
  }),
);
